/** Причины пропуска адресата (MARKETING_SKIP_REASONS на бэкенде). */
export const SKIP_REASON_KEYS: Record<string, string> = {
  UNSUBSCRIBED: "broadcasts.skip.UNSUBSCRIBED",
  NO_CONSENT: "broadcasts.skip.NO_CONSENT",
  SUPPRESSED: "broadcasts.skip.SUPPRESSED",
  FREQUENCY_CAP: "broadcasts.skip.FREQUENCY_CAP",
  QUOTA: "broadcasts.skip.QUOTA",
  NO_CONTENT: "broadcasts.skip.NO_CONTENT",
  ENROLLMENT_INACTIVE: "broadcasts.skip.ENROLLMENT_INACTIVE",
  NO_EMAIL: "broadcasts.skip.NO_EMAIL",
  AUTOMATION_INACTIVE: "broadcasts.skip.AUTOMATION_INACTIVE",
  MARKETING_DISABLED: "broadcasts.skip.MARKETING_DISABLED",
  EVENT_OBJECT_UNAVAILABLE: "broadcasts.skip.EVENT_OBJECT_UNAVAILABLE",
};
